import React, { createContext, useContext, useState, useEffect } from 'react';
import axiosClient from '../api/axiosClient';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem('fajtech_user');
    return saved ? JSON.parse(saved) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('fajtech_access_token');
      if (token) {
        try {
          const res = await axiosClient.get('/auth/me');
          setUser(res.data.user);
          localStorage.setItem('fajtech_user', JSON.stringify(res.data.user));
        } catch (error) {
          console.error('Auth verification failed:', error);
          setUser(null);
          localStorage.removeItem('fajtech_user');
          localStorage.removeItem('fajtech_access_token');
        }
      }
      setLoading(false);
    };
    checkAuth();
  }, []);

  const login = async (email, password) => {
    const res = await axiosClient.post('/auth/login', { email, password });
    const { user: userData, accessToken, refreshToken } = res.data;
    setUser(userData);
    localStorage.setItem('fajtech_user', JSON.stringify(userData));
    localStorage.setItem('fajtech_access_token', accessToken);
    localStorage.setItem('fajtech_refresh_token', refreshToken);
    return userData;
  };

  const logout = async () => {
    try {
      const refreshToken = localStorage.getItem('fajtech_refresh_token');
      await axiosClient.post('/auth/logout', { refreshToken });
    } catch (e) {
      console.error('Logout API call failed:', e);
    } finally {
      setUser(null);
      localStorage.removeItem('fajtech_user');
      localStorage.removeItem('fajtech_access_token');
      localStorage.removeItem('fajtech_refresh_token');
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
